const common = {
  site_name: '黑料吃瓜在线',
  site_slogan: '最新娱乐资讯，一手吃瓜速递',
  nav_home: '首页',
  nav_celebrity: '明星八卦',
  nav_influencer: '网红动态',
  nav_variety: '综艺热点',
  nav_film: '影视资讯',
  nav_about: '关于我们',
  read_more: '阅读全文',
  view_all: '查看全部',
  hot_now: '热门',
  latest: '最新',
  related: '相关推荐',
  subscribe: '订阅',
  subscribe_placeholder: '输入您的邮箱',
  subscribe_btn: '订阅',
  subscribe_desc: '订阅即可获得最新娱乐资讯推送',
  copyright: '© 2026 黑料吃瓜在线 版权所有',
  breadcrumb_home: '首页',
  minute_read: '分钟阅读',
  published_at: '发布于',
  category: '分类',
  loading: '加载中...',
  no_more: '没有更多了',
};

export default common;